import styled, { css } from 'styled-components';

const footerStyles = (p) => css`
  display: flex;
  grid-gap: ${(p) => p.theme.space[3]};
  justify-content: flex-end;

  * {
    margin: 0;
  }
`;

export const StyledModalPart = styled.div`
  padding: ${(p) => p.theme.space[6]};

  > * + * {
    margin-top: ${(p) => p.theme.space[3]};
  }

  ${(p) => p.isFooter && footerStyles(p)};
`;
